import script from "./SamplePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./SamplePreview.vue?vue&type=script&setup=true&lang=js"

import "./SamplePreview.vue?vue&type=style&index=0&id=d6a2485c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6a2485c"]])

export default __exports__